import { BonusCardFeedback } from "@/components/Account/RequestBonusCard/BonusCardFeedback/bonusCardFeedback.component";
import { BonusCardStatus } from "@/utils/enums";

type Props = {
    requestTitle: string;
    requestText: string;
    requestButtonText: string;
    thanksTitle: string;
    thanksText: string;
    onRouteTitle: string;
    onRouteText: string;
    bonusCardStatus: BonusCardStatus | null;
    openModal: () => void;
};

const BonusCardRequestComponent = ({
    requestTitle,
    requestText,
    requestButtonText,
    thanksTitle,
    thanksText,
    onRouteTitle,
    onRouteText,
    bonusCardStatus,
    openModal
}: Props) => (
    <>
        {bonusCardStatus === BonusCardStatus.NoCard && (
            <BonusCardFeedback
                title={requestTitle}
                text={requestText}
                buttonText={requestButtonText}
                onClick={openModal}
            />
        )}
        {bonusCardStatus === BonusCardStatus.Requested && (
            <BonusCardFeedback
                title={thanksTitle}
                text={thanksText}
            />
        )}
        {bonusCardStatus === BonusCardStatus.CardOnRoute && (
            <BonusCardFeedback
                title={onRouteTitle}
                text={onRouteText}
            />
        )}
    </>
);

export { BonusCardRequestComponent };
